import { call, restService } from './apiHelpers';

export const coordinatorService = {
  ...restService('coordinadores'),
  createForActor: (payload) => call('post', 'coordinadores/', payload),
};
